import { useAuthorization } from 'framework/authorization';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import IconButton from '@mui/material/IconButton';
import RemoveIcon from '@mui/icons-material/IndeterminateCheckBox';
import { CREATE_EDUCATION } from '../shared/types';

const DeleteEducationAction = ({ onDelete }: { onDelete: (id: string) => Promise<void> }) => {
  const { isGranted } = useAuthorization();

  if (!isGranted(CREATE_EDUCATION)) {
    return null;
  }

  return (
    <ButtonWithConfirmation
      modalConfirmButtonText="Delete"
      buttonTag={IconButton}
      sx={{
        p: 0,
        minWidth: 'auto',
      }}
      submitMethod={onDelete}
      displayMessage="Do you really want to delete education?"
      permissionToCheck={CREATE_EDUCATION}
    >
      <RemoveIcon />
    </ButtonWithConfirmation>
  );
};

export default DeleteEducationAction;
